import React from 'react'

const LandingPage = () => {
  return (
    <div className='landing-container'>
        <div className="content">
            <h1>Join Us</h1>
            <p>Build your career, build the future.</p>
        </div>
    </div>
  )
}

export default LandingPage